import { IDeleteConfigurarPagamentoColetaPrecoUseCase } from "../../../presentation/useCases/delete/delete_configurar_pagamento_coleta_preco_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteConfigurarPagamentoColetaPrecoUseCase
 */

export class DeleteConfigurarPagamentoColetaPrecoUseCase implements IDeleteConfigurarPagamentoColetaPrecoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteConfigurarPagamentoColetaPreco(
    idColetaPreco: number,
  ): Promise<void> {
    await this.repository.deleteConfigurarPagamentoColetaPreco(
      idColetaPreco,
    );
  }
}
